import { useCallback, useState } from "react";
import type { CreateServiceRequest } from "@/types/api";
import {
  buildFieldRules,
  EMPTY_FIELD_RULE,
  type FieldRuleRow,
} from "@/utils/fieldRules";
import {
  DEFAULT_EVENTS_PER_SECOND,
  eventsPerSecondPayload,
} from "./eventsPerSecond";
import { GeneratorFields } from "./GeneratorFields";
import { parseOptionalInt } from "./parseOptionalInt";

export function useGeneratorFields() {
  const [eventsPerSecond, setEventsPerSecond] = useState(
    DEFAULT_EVENTS_PER_SECOND,
  );
  const [totalEvents, setTotalEvents] = useState("");
  const [seed, setSeed] = useState("");
  const [rules, setRules] = useState<FieldRuleRow[]>([EMPTY_FIELD_RULE]);

  const toPayload = useCallback((): Partial<CreateServiceRequest> => {
    // An empty box means "not set": unbounded volume or an unseeded stream.
    // `fields` rides along only when at least one rule is filled in.
    const fields = buildFieldRules(rules);
    return {
      events_per_second: eventsPerSecondPayload(eventsPerSecond),
      total_events: parseOptionalInt(totalEvents),
      seed: parseOptionalInt(seed),
      ...(fields ? { fields } : {}),
    };
  }, [eventsPerSecond, totalEvents, seed, rules]);

  const fields = (
    <GeneratorFields
      eventsPerSecond={eventsPerSecond}
      setEventsPerSecond={setEventsPerSecond}
      totalEvents={totalEvents}
      setTotalEvents={setTotalEvents}
      seed={seed}
      setSeed={setSeed}
      rules={rules}
      setRules={setRules}
    />
  );

  return { fields, toPayload };
}
